import React from "react";
import { Grid, Paper } from "@mui/material";
import { IOriginCountries } from '../../models/registrationModels';
import RsDataField from "./RsDataField";
import GridItemContainer from "../layout/GridItemContainer";

const RsTravelGroup = ({ originCountries }: { originCountries: IOriginCountries[] }) => {
  
  return (
    <Paper elevation={2} sx={{overflow:"hidden"}}>
      <Grid container>
          <GridItemContainer border isHeader xs={12}>
            <RsDataField labelStrong="REISEGRUPPE" labelSmall="Aufgliederung nach Herkunftsland (Traveller group per country of origin)" isHeader />
          </GridItemContainer>
        {originCountries.map((originCountry, index) => (
          <React.Fragment key={`${originCountry.name}_${index}`}>
            <GridItemContainer border xs={8}>
              <RsDataField labelStrong="HERKUNFTSLAND" labelSmall="(country of origin)" value={originCountry.name} />
            </GridItemContainer>
            <GridItemContainer border xs={4}>
              <RsDataField labelStrong="ANZAHL" labelSmall="(number)" value={originCountry.sum.toString()} />
            </GridItemContainer>
          </React.Fragment>
        ))}
      </Grid >
    </Paper>
  );
};

export default RsTravelGroup;
